"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _storageLocal = require("./storageLocal");
Object.keys(_storageLocal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _storageLocal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _storageLocal[key];
    }
  });
});
var _storageSession = require("./storageSession");
Object.keys(_storageSession).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _storageSession[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _storageSession[key];
    }
  });
});
